import { Administrator } from '@favid-inc/api';
import { Modal } from 'core/modal';
import React from 'react';

interface Props {
  administrator: Administrator;
  onCloseModal: () => void;
  onConfirmDelete: () => void;
}

export class ModalConfirmRemoveAdm extends React.Component<Props> {
  renderActions() {
    return (
      <React.Fragment>
        <div className='ui button' onClick={this.props.onCloseModal}>
          Cancelar
        </div>
        <div className='ui button red' onClick={this.props.onConfirmDelete}>
          Apagar
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal
        header='Tem certeza que deseja remover este administrador?'
        content={this.props.administrator.email}
        isOpen={true}
        actions={this.renderActions()}
        handleClose={this.props.onCloseModal}
      />
    );
  }
}
